<swal #warnDateValidAlert
  title="Warning"
  i18n-title
  text="Invalid Date"
  i18n-text icon="warning"
  html=""
  [swalOptions]="swalOptions">
</swal>
<form [formGroup]="paymentdueDateForm" novalidate>
  <div class="formfields" fxLayout="row wrap">
    <div class="formfields__container"  [fxFlex]="warningText && warningText !== '' ? 50 : isSummaryOrReview ? 100 : 100">
      <mat-form-field floatPlaceholder="never">
        <label for="payment_due_date"><span i18n>Payment Due Date</span><span *ngIf="isRequired" class="required">*</span></label>
        <input
          matInput
          formControlName="payment_due_date"
          id="payment_due_date"
          [matDatepicker]="paymentDuedatepicker"
          [placeholder]="!transaction.payment_due_date && getUserCountry() !== 'JPN' ? 'DD/MM/YYYY'
          : !transaction.payment_due_date && getUserCountry() === 'JPN'? 'YYYY/MM/DD' : ''"
          floatPlaceholder="never"
          (dateChange)="validateDate($event)"
          (blur)="validateDate($event)" />
        <mat-datepicker-toggle matSuffix [for]="paymentDuedatepicker">
          <mat-icon>date_range</mat-icon>
        </mat-datepicker-toggle>
      </mat-form-field>
      <mat-datepicker #paymentDuedatepicker></mat-datepicker>
    </div>
    <div *ngIf="warningText && warningText !== '' && !isSummaryOrReview" class="formfields__container" fxFlex="50">
      <div class="msg-bubble">
        <mat-icon>announcement</mat-icon>
        <span>{{ warningText }}</span>
      </div>
    </div>
  </div>
</form>
